// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'News Letters': 'النشرة البريدية',
  'Download CSV': 'تحميل الملف',
  title: 'الاسم',
  OPTIONS: 'خيارات',
  'Add Email': 'إضافة بريد إلكتروني',
};
